// document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".cf-trigger").addEventListener("click", openDrawer);
  document
    .querySelector(".cf-drawer__close-button")
    .addEventListener("click", closeDrawer);
  document.querySelector(".cf-drawer-backdrop").addEventListener('click', (e)=>{closeDrawer()});
// });


function openDrawer() {
  console.log("open drawer");
  document.querySelector(".cf-drawer").classList.add("open");
  document.querySelector(".cf-drawer-backdrop").classList.add("show");
}

function closeDrawer() {
  document.querySelector(".cf-drawer").classList.remove("open");
  document.querySelector(".cf-drawer-backdrop").classList.remove("show");
}

function applyFilters() {
    document.getElementById("filter-submit").click(); // Triggers form submission
}

function resetFilters() {
    // Redirect to the collection page without filters
    window.location.href = window.location.pathname;
}